import { render, staticRenderFns } from "./form-details-widget.vue?vue&type=template&id=6573733f&"
import script from "./form-details-widget.vue?vue&type=script&lang=js&"
export * from "./form-details-widget.vue?vue&type=script&lang=js&"
import style0 from "./form-details-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports